var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MenuTitle',{attrs:{"close":_vm.close}},[_vm._v(_vm._s(_vm.$t('model.footerImage')))]),_vm._v(" "),_c('menu-item',{staticClass:"pt-0",attrs:{"label":_vm.$t('customImage')}},[_c('menu-background-image',{attrs:{"target":_vm.target,"image-key":"image","eye-key":"","image-opacity-key":"","suggestion":{
       extra: _vm.$t('upload.extra31')
    }}})],1),_vm._v(" "),_c('DeleteBlockDialogTrigger',{on:{"delete-block":_vm.deleteBlock}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }